// Mid-Year/3rd Trimester has no standard 12-unit base load — every unit
// taught that term counts as overload, capped at 6.
function isMidYearTerm(term) {
  return (
    typeof term === "string" &&
    term.startsWith("Mid-Year Term/3rd Trimester")
  );
}

export function classifyLoad(load, term) {
  if (isMidYearTerm(term)) {
    return { status: "Overload", units: load >= 6 ? 6 : load };
  }

  if (load === 12) return { status: "Normal", units: 0 };
  if (load < 12) return { status: "Underload", units: 12 - load };
  if (load <= 18) return { status: "Overload", units: load - 12 };
  return { status: "Overload", units: 6 };
}

export const LOAD_STATUS_COLORS = {
  Normal: "green",
  Underload: "orange",
  Overload: "red",
};
